import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=206d7688&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=206d7688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d7688",
  null
  
)

export default component.exports